
import { supabase } from '@/integrations/supabase/client';
import type { ConsentCategories, ConsentData, GDPRSettings } from './types';
import { generateSessionId, saveConsentToStorage } from './storage';
import { updateConsentMode } from './consentMode';

export const saveConsentToDatabase = async (consentData: ConsentData): Promise<void> => {
  const sessionId = generateSessionId();
  
  try {
    await supabase.from('user_consents').insert({
      user_session_id: sessionId,
      consent_data: consentData as any,
      consent_version: consentData.version,
      consent_timestamp: consentData.timestamp,
      ip_address: null,
      user_agent: navigator.userAgent,
    });
  } catch (error) {
    // Silent error handling
  }
};

export const saveConsent = async (
  consents: ConsentCategories,
  gdprSettings: GDPRSettings | null,
  setConsentData: (data: ConsentData) => void,
  setShowBanner: (show: boolean) => void
): Promise<void> => {
  const sessionId = generateSessionId();
  const consentTimestamp = new Date().toISOString();
  const version = '1.0';

  const fullConsentData: ConsentData = {
    ...consents,
    timestamp: consentTimestamp,
    version,
  };

  try {
    // Save to localStorage first
    saveConsentToStorage(fullConsentData);
    setConsentData(fullConsentData);

    // Hide banner immediately after saving consent
    setShowBanner(false);

    // Save to database asynchronously to not block UI
    const saveToDatabase = async () => {
      try {
        await supabase.from('user_consents').insert({
          user_session_id: sessionId,
          consent_data: fullConsentData as any,
          consent_version: version,
          consent_timestamp: consentTimestamp,
          ip_address: null,
          user_agent: navigator.userAgent,
        });

        // Update Google Consent Mode if enabled
        updateConsentMode(gdprSettings, consents);
      } catch (error) {
        // Silent error handling
      }
    };

    // Use requestIdleCallback or setTimeout to defer database save
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => saveToDatabase());
    } else {
      setTimeout(saveToDatabase, 0);
    }
  } catch (error) {
    // Silent error handling
  }
};
